/* eslint-disable operator-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable css-modules/no-undef-class */
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Row, Col, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import { Doughnut } from 'react-chartjs-2';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import gql from 'graphql-tag';
import { withRouter } from 'react-router';
import moment from 'moment';

import Loading from 'components/Loading';
import AuthenticationWrapper from 'components/Auth/AuthenticationWrapper';
import meQuery from 'components/Auth/queries/meQuery';
import {
  NOW,
  CURRENT_MONTH_FROM,
  LAST_12_MONTHS_TO,
  LAST_12_MONTHS_FROM,
} from '../../constants';

import s from './Dashboard.scss';
import layoutStyle from '../../styles/base/layout.scss';
import employeeBalanceMessages from '../EmployeeBalance/messages';
import variables from '../../styles/base/variables.scss';
import RatioPanel from '../Controlling/Ratios/RatioPanel';
import { DATEONLY_STRING_FMT_DB } from '../../core/dateonly';
import ReportDataMetricsHorizontal from '../OfficeEnvMetrics/ReportDataMetricsHorizontal';
import LiveEnvMetrics from '../OfficeEnvMetrics/LiveEnvMetrics';

const doughnutOptions = {
  plugins: {
    datalabels: {
      display: false,
    },
  },
  tooltips: {
    enabled: true,
    callbacks: {
      label: (tooltipitem, data) =>
        `${data.labels[tooltipitem.index]}: ${
          data.datasets[tooltipitem.datasetIndex].data[tooltipitem.index]
        }h`,
    },
  },
};

const reportDataShape = PropTypes.shape({
  loading: PropTypes.bool,
  report: PropTypes.arrayOf(
    PropTypes.shape({
      powerTotal: PropTypes.number,
      lightHoursTotal: PropTypes.string,
      mainDoorOpenHoursTotal: PropTypes.string,
      allWindowsOpenHoursTotal: PropTypes.string,
      co2Metrics: PropTypes.shape({
        max: PropTypes.number,
        mean: PropTypes.number,
        min: PropTypes.number,
      }),
      temperatureMetrics: PropTypes.shape({
        max: PropTypes.number,
        mean: PropTypes.number,
        min: PropTypes.number,
      }),
      humidityMetrics: PropTypes.shape({
        max: PropTypes.number,
        mean: PropTypes.number,
        min: PropTypes.number,
      }),
    }).isRequired,
  ).isRequired,
});

const envDataShape = PropTypes.shape({
  loading: PropTypes.bool,
  currentEnvironmentData: PropTypes.arrayOf(
    PropTypes.shape({
      entityId: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
});

class Dashboard extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      refetch: PropTypes.func.isRequired,
      me: PropTypes.shape({
        username: PropTypes.string.isRequired,
        hoursStatistics: PropTypes.shape({
          billableHours: PropTypes.number.isRequired,
          nonBillableHours: PropTypes.number.isRequired,
          projectHours: PropTypes.arrayOf(
            PropTypes.shape({
              name: PropTypes.string.isRequired,
              hours: PropTypes.number.isRequired,
              billable: PropTypes.bool.isRequired,
            }).isRequired,
          ),
        }),
        weeklyBalance: PropTypes.shape({
          done: PropTypes.number.isRequired,
          total: PropTypes.number.isRequired,
        }).isRequired,
        monthlyBalance: PropTypes.shape({
          done: PropTypes.number.isRequired,
          total: PropTypes.number.isRequired,
        }).isRequired,
      }),
    }).isRequired,
    dataWeekly: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      me: PropTypes.shape({
        hoursStatistics: PropTypes.shape({
          projectHours: PropTypes.arrayOf(
            PropTypes.shape({
              name: PropTypes.string.isRequired,
              hours: PropTypes.number.isRequired,
              billable: PropTypes.bool.isRequired,
            }).isRequired,
          ),
        }),
      }),
    }).isRequired,
    dataMonthly: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      me: PropTypes.shape({
        hoursStatistics: PropTypes.shape({
          projectHours: PropTypes.arrayOf(
            PropTypes.shape({
              name: PropTypes.string.isRequired,
              hours: PropTypes.number.isRequired,
              billable: PropTypes.bool.isRequired,
            }).isRequired,
          ),
        }),
      }),
    }).isRequired,
    envDataStreetSide: envDataShape.isRequired,
    envDataYardSide: envDataShape.isRequired,
    envDataMeetingRoom: envDataShape.isRequired,
    reportData: reportDataShape.isRequired,
    reportDataAverage: reportDataShape.isRequired,
    intl: intlShape.isRequired,
    showWorkCategory: PropTypes.bool.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.createWorkCategoryData = this.createWorkCategoryData.bind(this);
    this.createShortWorkData = this.createShortWorkData.bind(this);
  }

  componentDidMount() {
    const redirect = window.localStorage.getItem('redirect');
    if (redirect) {
      window.localStorage.removeItem('redirect');
      this.props.history.push(redirect);
    }
  }

  async onChange(interval) {
    let filter = {};
    if (interval === 'monthly') {
      filter = {
        from: moment()
          .startOf('month')
          .format(DATEONLY_STRING_FMT_DB),
        to: moment()
          .endOf('month')
          .format(DATEONLY_STRING_FMT_DB),
        active: true,
      };
    } else {
      filter = {
        from: moment()
          .startOf('week')
          .format(DATEONLY_STRING_FMT_DB),
        to: moment()
          .endOf('week')
          .format(DATEONLY_STRING_FMT_DB),
        active: true,
      };
    }
    this.props.data.refetch({
      filter,
    });
  }
  createShortWorkData() {
    const { data: { me }, intl } = this.props;
    const balance = me.activeShortWorkBalance;
    if (!balance) return null;
    let labels;
    let balanceData;
    let shortWorkData = {};
    const labelDone = intl.formatMessage(employeeBalanceMessages.done);
    const labelRemaining = intl.formatMessage(
      employeeBalanceMessages.remaining,
    );
    const labelMin = intl.formatMessage(employeeBalanceMessages.underMinimum);
    const labelMax = intl.formatMessage(employeeBalanceMessages.overMaximum);
    if (balance.done < balance.minHours) {
      labels = [labelDone, labelMin, labelRemaining];
      balanceData = [
        balance.done.toFixed(2),
        (balance.minHours - balance.done).toFixed(2),
        (balance.maxHours - balance.minHours).toFixed(2),
      ];
      shortWorkData = {
        labels,
        datasets: [
          {
            data: balanceData,
            // eslint-disable-next-line css-modules/no-undef-class
            backgroundColor: [variables.teal, variables.orange, variables.grey],
          },
        ],
      };
    } else if (
      balance.done >= balance.minHours &&
      balance.done < balance.maxHours
    ) {
      labels = [labelDone, labelRemaining];
      balanceData = [
        balance.done.toFixed(2),
        (balance.maxHours - balance.done).toFixed(2),
      ];
      shortWorkData = {
        labels,
        datasets: [
          {
            data: balanceData,
            // eslint-disable-next-line css-modules/no-undef-class
            backgroundColor: [variables.teal, variables.grey],
          },
        ],
      };
    } else {
      labels = [labelDone, labelMax];
      balanceData = [
        balance.maxHours.toFixed(2),
        (balance.done - balance.maxHours).toFixed(2),
      ];
      shortWorkData = {
        labels,
        datasets: [
          {
            data: balanceData,
            // eslint-disable-next-line css-modules/no-undef-class
            backgroundColor: [variables.teal, variables.orange],
          },
        ],
      };
    }
    return shortWorkData;
  }

  createWorkCategoryData(data, weekly) {
    const {
      intl,
      data: {
        me: {
          weeklyBalance,
          monthlyBalance,
          weeklyNonWorkEntries,
          monthlyNonWorkEntries,
        },
      },
    } = this.props;

    const groupedWorkCategory = data.reduce((all, current) => {
      if (current.workCategory && all[current.workCategory.name]) {
        all[current.workCategory.name].hours =
          all[current.workCategory.name].hours + current.hours;
      } else if (current.workCategory) {
        all[current.workCategory.name] = {
          hours: current.hours,
          name: current.workCategory.name,
          color: current.workCategory.color,
        };
      } else if (all.rest) {
        all.rest.hours = all.rest.hours + current.hours;
      } else
        all.rest = {
          hours: current.hours,
          name: intl.formatMessage(employeeBalanceMessages.done),
          color: variables.teal,
        };
      return all;
    }, {});
    const keys = Object.keys(groupedWorkCategory);
    const nonWorkLabels = weekly
      ? weeklyNonWorkEntries.map(
          entry =>
            employeeBalanceMessages[entry.type]
              ? intl.formatMessage(employeeBalanceMessages[entry.type])
              : entry.type,
        )
      : monthlyNonWorkEntries.map(
          entry =>
            employeeBalanceMessages[entry.type]
              ? intl.formatMessage(employeeBalanceMessages[entry.type])
              : entry.type,
        );
    const nonWorkData = weekly
      ? weeklyNonWorkEntries.map(entry => entry.hours)
      : monthlyNonWorkEntries.map(entry => entry.hours);
    const nonWorkColor = weekly
      ? weeklyNonWorkEntries.map(
          entry => (variables[entry.type] ? variables[entry.type] : '#000000'),
        )
      : monthlyNonWorkEntries.map(
          entry => (variables[entry.type] ? variables[entry.type] : '#000000'),
        );

    const dataSet = {
      labels: [
        ...keys.map(key => groupedWorkCategory[key].name),
        ...nonWorkLabels,
        intl.formatMessage(employeeBalanceMessages.remaining),
      ],
      datasets: [
        {
          data: [
            ...keys.map(key => groupedWorkCategory[key].hours.toFixed(2)),
            ...nonWorkData,
            weekly
              ? Math.max(
                  0,
                  (weeklyBalance.total - weeklyBalance.done).toFixed(2),
                )
              : Math.max(
                  0,
                  (monthlyBalance.total - monthlyBalance.done).toFixed(2),
                ),
          ],
          backgroundColor: [
            ...keys.map(key => groupedWorkCategory[key].color),
            ...nonWorkColor,
            variables.grey,
          ],
        },
      ],
    };
    return dataSet;
  }

  render() {
    const {
      data: { loading, me },
      intl,
      showWorkCategory,
      dataWeekly,
      dataMonthly,
    } = this.props;
    if (
      (loading ||
        (showWorkCategory && (dataWeekly.loading || dataMonthly.loading))) &&
      (!me ||
        !me.hoursStatistics ||
        (showWorkCategory &&
          (!dataWeekly.me ||
            !dataWeekly.me.hoursStatistics ||
            !dataMonthly.me ||
            !dataMonthly.me.hoursStatistics)))
    )
      return <Loading />;
    const shortWorkData = this.createShortWorkData();
    const { hoursStatistics } = me;
    const totalHours = {
      billableHours: hoursStatistics.billableHours,
      nonBillableHours: hoursStatistics.nonBillableHours,
    };
    const weeklyBalanceData = {
      labels: [
        intl.formatMessage(employeeBalanceMessages.done),
        intl.formatMessage(employeeBalanceMessages.remaining),
      ],
      datasets: [
        {
          data: [
            me.weeklyBalance.done.toFixed(2),
            Math.max(
              0,
              (me.weeklyBalance.total - me.weeklyBalance.done).toFixed(2),
            ),
          ],
          // eslint-disable-next-line css-modules/no-undef-class
          backgroundColor: [variables.teal, variables.grey],
        },
      ],
    };

    const monthlyBalanceData = {
      labels: [
        intl.formatMessage(employeeBalanceMessages.done),
        intl.formatMessage(employeeBalanceMessages.remaining),
      ],
      datasets: [
        {
          data: [
            me.monthlyBalance.done.toFixed(2),
            Math.max(
              0,
              (me.monthlyBalance.total - me.monthlyBalance.done).toFixed(2),
            ),
          ],
          // eslint-disable-next-line css-modules/no-undef-class
          backgroundColor: [variables.teal, variables.grey],
        },
      ],
    };
    let colSpan = 4;
    if (shortWorkData) colSpan = 3;
    return [
      <Row key="chartRow" className={layoutStyle.noMargin}>
        <Col md={colSpan} xs={12} className={layoutStyle.noPadding}>
          <label htmlFor="weeklyChart">
            <FormattedMessage {...employeeBalanceMessages.weeklyBalance} />
          </label>
          <Doughnut
            name="weeklyChart"
            data={
              showWorkCategory
                ? this.createWorkCategoryData(
                    dataWeekly.me.hoursStatistics.projectHours,
                    true,
                  )
                : weeklyBalanceData
            }
            options={doughnutOptions}
          />
        </Col>
        <Col md={colSpan} xs={12} className={layoutStyle.noPadding}>
          <label htmlFor="monthlyChart">
            <FormattedMessage {...employeeBalanceMessages.monthlyBalance} />
          </label>
          <Doughnut
            name="monthlyChart"
            data={
              showWorkCategory
                ? this.createWorkCategoryData(
                    dataMonthly.me.hoursStatistics.projectHours,
                  )
                : monthlyBalanceData
            }
            options={doughnutOptions}
          />
        </Col>
        {shortWorkData && (
          <Col md={colSpan} xs={12} className={layoutStyle.noPadding}>
            <label htmlFor="shortWorkChart">
              <FormattedMessage {...employeeBalanceMessages.shortWorkBalance} />
            </label>
            <Doughnut
              name="shortWorkChart"
              data={shortWorkData}
              options={doughnutOptions}
            />
          </Col>
        )}
        <Col md={colSpan} xs={12} className={layoutStyle.noPadding}>
          <label htmlFor="projectStatistics" style={{ display: 'block' }}>
            <FormattedMessage {...employeeBalanceMessages.projectStatistics} />
          </label>
          <ToggleButtonGroup
            name="interval"
            type="radio"
            onChange={this.onChange}
            defaultValue="monthly"
          >
            <ToggleButton value="monthly">
              <FormattedMessage {...employeeBalanceMessages.monthly} />
            </ToggleButton>
            <ToggleButton value="weekly">
              <FormattedMessage {...employeeBalanceMessages.weekly} />
            </ToggleButton>
          </ToggleButtonGroup>
          <RatioPanel
            title={me.username}
            totalData={totalHours}
            projectData={hoursStatistics.projectHours}
            initialShow
            showWorkCategory={showWorkCategory}
          />
        </Col>
      </Row>,
      <Row key="envMetricsRow" className={layoutStyle.envMetricsRow}>
        <Col lg={6} md={8} xs={12}>
          <ReportDataMetricsHorizontal
            title="Current months metrics"
            loading={this.props.reportData.loading}
            data={this.props.reportData.report}
          />
        </Col>
        <Col lg={6} md={8} xs={12}>
          <ReportDataMetricsHorizontal
            title="Average Metrics (Last 12 Months)"
            loading={this.props.reportDataAverage.loading}
            data={this.props.reportDataAverage.report}
            average
          />
        </Col>
      </Row>,
      <Row style={{ marginTop: '2em' }}>
        <Col lg={3} md={4} xs={12}>
          <LiveEnvMetrics
            title="Live Street Side Office Metrics"
            loading={this.props.envDataStreetSide.loading}
            data={this.props.envDataStreetSide.currentEnvironmentData}
          />
        </Col>
        <Col lg={3} md={4} xs={12}>
          <LiveEnvMetrics
            title="Live Yard Side Office Metrics"
            loading={this.props.envDataYardSide.loading}
            data={this.props.envDataYardSide.currentEnvironmentData}
          />
        </Col>
        <Col lg={3} md={4} xs={12}>
          <LiveEnvMetrics
            title="Live Meeting Room Metrics"
            loading={this.props.envDataMeetingRoom.loading}
            data={this.props.envDataMeetingRoom.currentEnvironmentData}
          />
        </Col>
      </Row>,
    ];
  }
}

const currentEnvironmentDataQuery = gql`
  query currentEnvironmentData($entityIds: [String]) {
    currentEnvironmentData(entityIds: $entityIds) {
      entityId
      value
    }
  }
`;

const reportDataQuery = gql`
  query report($from: String, $to: String) {
    report(from: $from, to: $to) {
      powerTotal
      lightHoursTotal
      mainDoorOpenHoursTotal
      allWindowsOpenHoursTotal
      co2Metrics {
        max
        mean
        min
      }
      temperatureMetrics {
        max
        mean
        min
      }
      humidityMetrics {
        max
        mean
        min
      }
      homeOfficeWorkHoursTotal
      officeWorkHoursTotal
      homeOfficeWorkHoursAvg
      officeWorkHoursAvg
    }
  }
`;

// const timeSeriesDataQuery = gql`
//   query timeSeries($from: String, $to: String) {
//     timeSeries(from: $from, to: $to) {
//       power_plugs_consumption {
//         ikea_smart_plug_1_energy {
//           time
//           value
//         }
//         ikea_smart_plug_2_energy {
//           time
//           value
//         }
//         ikea_smart_plug_3_energy {
//           time
//           value
//         }
//         ikea_smart_plug_4_energy {
//           time
//           value
//         }
//       }
//       lights_consumption {
//         lights_hallway_energy {
//           time
//           value
//         }
//         lights_kitchen_energy {
//           time
//           value
//         }
//         lights_meeting_room_energy {
//           time
//           value
//         }
//         lights_office_streetside_energy {
//           time
//           value
//         }
//         lights_office_yardside_energy {
//           time
//           value
//         }
//       }
//     }
//   }
// `;

export default AuthenticationWrapper(
  compose(
    graphql(meQuery, {
      name: 'data',
      options: () => ({
        variables: {
          filter: {
            from: moment()
              .startOf('month')
              .format(DATEONLY_STRING_FMT_DB),
            to: moment()
              .endOf('month')
              .format(DATEONLY_STRING_FMT_DB),
            active: true,
          },
        },
      }),
    }),
    graphql(meQuery, {
      name: 'dataWeekly',
      skip: props => !props.showWorkCategory,
      options: () => ({
        variables: {
          filter: {
            from: moment()
              .startOf('week')
              .format(DATEONLY_STRING_FMT_DB),
            to: moment()
              .endOf('week')
              .format(DATEONLY_STRING_FMT_DB),
            active: true,
          },
        },
      }),
    }),
    graphql(meQuery, {
      name: 'dataMonthly',
      skip: props => !props.showWorkCategory,
      options: () => ({
        variables: {
          filter: {
            from: moment()
              .startOf('month')
              .format(DATEONLY_STRING_FMT_DB),
            to: moment()
              .endOf('month')
              .format(DATEONLY_STRING_FMT_DB),
            active: true,
          },
        },
      }),
    }),
    graphql(currentEnvironmentDataQuery, {
      name: 'envDataStreetSide',
      options: () => ({
        variables: {
          entityIds: [
            'switchbot_meter_pro_1_luftfeuchtigkeit',
            'switchbot_meter_pro_1_temperatur',
            'switchbot_meter_pro_1_kohlendioxid',
          ],
        },
      }),
    }),
    graphql(currentEnvironmentDataQuery, {
      name: 'envDataYardSide',
      options: () => ({
        variables: {
          entityIds: [
            'switchbot_meter_pro_3_humidity',
            'switchbot_meter_pro_3_temperature',
            'switchbot_meter_pro_3_carbon_dioxide',
          ],
        },
      }),
    }),
    graphql(currentEnvironmentDataQuery, {
      name: 'envDataMeetingRoom',
      options: () => ({
        variables: {
          entityIds: [
            'meter_pro_co2_0b6c_humidity',
            'meter_pro_co2_0b6c_temperature',
            'meter_pro_co2_0b6c_carbon_dioxide',
          ],
        },
      }),
    }),
    graphql(reportDataQuery, {
      name: 'reportData',
      options: () => ({
        variables: {
          from: CURRENT_MONTH_FROM.toISOString(),
          to: NOW.toISOString(),
        },
      }),
    }),
    graphql(reportDataQuery, {
      name: 'reportDataAverage',
      options: () => ({
        variables: {
          from: LAST_12_MONTHS_FROM.toISOString(),
          to: LAST_12_MONTHS_TO.toISOString(),
        },
      }),
    }),
  )(withRouter(injectIntl(withStyles(layoutStyle, s)(Dashboard)))),
);
